/** What is left of the space level once the editor's tray holds the rest: two addresses. */

export const SPACE_TAB_IDS = ["control", "runs"] as const;

export type SpaceTab = (typeof SPACE_TAB_IDS)[number];

export const SPACE_TAB_LABELS: Record<SpaceTab, string> = {
  control: "Control",
  runs: "Runs",
};

export const SPACE_TAB_ROUTES = {
  control: "/console/spaces/$joinCode/control",
  runs: "/console/spaces/$joinCode/runs",
} as const;
